'use client';
import React from 'react';
import TextField from '@mui/material/TextField';
import { Box, Typography } from '@mui/material';
import { Control, Controller, UseFormSetValue } from 'react-hook-form';

import { FormCard } from '../../../ui/shared';
import { Profile } from '../../types/profile';
import { Profile as DictProfile } from '@/shared/i18n';
import ImageUpload from './image-upload';

interface PersonalInfoProps {
  control: Control<Profile>;
  setValue: UseFormSetValue<Profile>;
  dict: DictProfile['profile'];
  profilePicture: string | undefined | null;
}

const PersonalInfo: React.FC<PersonalInfoProps> = ({ control, dict, setValue, profilePicture }) => {
  return (
    <FormCard title="Informazioni personali">
      <div className="sm:flex w-full flex-wrap gap-6">
        <Controller
          name="profilePicture"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <ImageUpload
              label={dict.info_img_btn_text}
              defaultImage={profilePicture || ''}
              onFileChange={(_, fileBase64) => {
                if (!fileBase64) {
                  setValue(field.name, null);
                  return;
                }
                setValue(field.name, fileBase64);
              }}
              fieldError={error}
            />
          )}
        />
        <Box className="w-full flex flex-col flex-1 gap-6">
          <Box className="flex flex-wrap md:flex-nowrap gap-6">
            <Controller
              name="name"
              control={control}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  label={<Typography variant="s2">{dict.info_name}</Typography>}
                  fullWidth
                  variant="outlined"
                  {...field}
                  error={!!error}
                  helperText={!!error && dict.info_name_mandatory}
                />
              )}
            />
            <Controller
              name="surname"
              control={control}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  label={<Typography variant="s2">{dict.info_surname}</Typography>}
                  fullWidth
                  variant="outlined"
                  {...field}
                  error={!!error}
                  helperText={!!error && dict.info_surname_mandatory}
                />
              )}
            />
          </Box>
          <Box className="flex flex-wrap md:flex-nowrap gap-6">
            <Controller
              name="city"
              control={control}
              render={({ field }) => (
                <TextField
                  label={<Typography variant="s2">{dict.info_city}</Typography>}
                  fullWidth
                  variant="outlined"
                  {...field}
                  value={field.value || ''}
                />
              )}
            />
            <Controller
              name="email"
              control={control}
              render={({ field }) => (
                <TextField
                  label={<Typography variant="s2">{dict.info_email}</Typography>}
                  fullWidth
                  variant="outlined"
                  {...field}
                  disabled
                />
              )}
            />
          </Box>
        </Box>
      </div>

      <Controller
        name="additionalInfo"
        control={control}
        render={({ field }) => (
          <TextField
            label={<Typography variant="s2">{dict.info_biography}</Typography>}
            placeholder={dict.info_biography_placeholder}
            multiline
            rows={4}
            fullWidth
            variant="outlined"
            {...field}
            value={field.value || ''}
          />
        )}
      />
    </FormCard>
  );
};

export default PersonalInfo;
